// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__xmKqK","loader":"loader_loader__66seJ","load":"loader_load__q2gZj"};